import React from "react";
import Column from "@amzn/meridian/column";
import {FormattedMessage, injectIntl} from "react-intl";
import Text from "@amzn/meridian/text";
import Input from "@amzn/meridian/input";
import {
    getAisleNamePattern,
    isLedPortRangeWithinLimit,
    isValidEntry,
    isValidLedPortNumber,
    PATTERNS
} from "../../../util/Validations";
import {getAisleName} from "../../../util/LEDControllerUtil";
import SearchableSelectModal from "../../../commonui/SearchableSelectModal";
import {DEFAULT_AISLE_TYPE} from "../../../util/Constants";
import PropTypes from "prop-types";

export const AisleRangeInputModal = (props) => {

    const {formatMessage} = props.intl;
    const {startAisle, setStartAisle, startAisleError, setStartAisleError,
        startPort, setStartPort, startPortError, setStartPortError,
        aisleCount, setAisleCount, aisleCountError, setAisleCountError,
        aisleType, setAisleType, aisleTypeError, setAisleTypeError,
        getAisleTypeOptions, stateValues, maxPorts} = props;
    const {startPortNumber, aisleCount: aisleCountValue} = stateValues.ledControllerConfig;


    return (
        <Column>
            <Column spacing="200">
                <Text tag="label" type="b200" color="primary" htmlFor="start-aisle-input">
                    <FormattedMessage id="modal.startAisle" defaultMessage="Start Aisle"/>
                </Text>
                <Input id="start-aisle-input"
                       value={startAisle}
                       onChange={setStartAisle}
                       onBlur={() => setStartAisleError(!isValidEntry(stateValues.ledControllerConfig.startAisleLabel, getAisleNamePattern()))}
                       error={startAisleError}
                       placeholder={getAisleName()}
                />
            </Column>
            <Column spacing="200">
                <Text tag="label" type="b200" color="primary" htmlFor="start-port-input">
                    <FormattedMessage id="modal.startPort"
                                      defaultMessage="Start Port"/>
                </Text>
                <Input id="start-port-input"
                       value={startPort}
                       onChange={setStartPort}
                       onBlur={() => setStartPortError(!isValidLedPortNumber(startPortNumber, maxPorts))}
                       error={startPortError}
                />
            </Column>
            <Column spacing="200">
                <Text tag="label" type="b200" color="primary" htmlFor="aisle-count-input">
                    <FormattedMessage id="modal.aisleCount"
                                      defaultMessage="Aisle Count"/>
                </Text>
                <Input id="aisle-count-input"
                       value={aisleCount}
                       onChange={setAisleCount}
                       onBlur={() => setAisleCountError(!isValidEntry(aisleCountValue, PATTERNS.INTEGER) ||
                           (isValidLedPortNumber(startPortNumber, maxPorts) &&
                               !isLedPortRangeWithinLimit(startPortNumber, aisleCountValue, maxPorts)))}
                       error={aisleCountError}
                />
            </Column>
            <Column spacing="200">
                <Text tag="label" type="b200" color="primary" htmlFor="searchable-input">
                    <FormattedMessage id={formatMessage({id: "modal.aisletype"})} defaultMessage="Aisle Type" />
                </Text>
                <SearchableSelectModal preSelectedValue={DEFAULT_AISLE_TYPE}
                                       error={aisleTypeError} setError={setAisleTypeError}
                                       selectedValue={aisleType} setSelectedValue={setAisleType}
                                       options={getAisleTypeOptions}
                                       htmlId="searchable-input"
                                       placeholderValue={formatMessage({id: "modal.selectAisleType"})}
                                       placeholderDefaultValue={"Select Aisle Type"}/>
            </Column>
        </Column>
    )
}

AisleRangeInputModal.propTypes = {
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired
    }).isRequired,
    startAisle: PropTypes.string,
    setStartAisle: PropTypes.func,
    startAisleError: PropTypes.bool.isRequired,
    setStartAisleError: PropTypes.func.isRequired,
    startPort: PropTypes.number,
    setStartPort: PropTypes.func,
    startPortError: PropTypes.bool.isRequired,
    setStartPortError: PropTypes.func.isRequired,
    aisleCount: PropTypes.number,
    setAisleCount: PropTypes.func,
    aisleCountError: PropTypes.bool.isRequired,
    setAisleCountError: PropTypes.func.isRequired,
    aisleType: PropTypes.string,
    setAisleType: PropTypes.func,
    aisleTypeError: PropTypes.bool.isRequired,
    setAisleTypeError: PropTypes.func.isRequired,
    getAisleTypeOptions: PropTypes.array.isRequired,
    stateValues: PropTypes.object.isRequired,
    maxPorts: PropTypes.number
};


export default injectIntl(AisleRangeInputModal);


// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/modal/AisleRangeInputModal.js